import React from "react";
import { AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import { useTranslation } from "react-i18next";
import { PAGINATION_DEFAULT } from "src/constant/common";
import TableCommon from "src/components/Common/Table";
import { columns } from "./column";
import useUrlState from "@ahooksjs/use-url-state";

const FilesHistory = ({ fileHistories, isFetchingFileHistories }) => {
  const { t } = useTranslation("test-package");
  const [params, setParams] = useUrlState(
    {},
    {
      navigateMode: "replace",
      stringifyOptions: {
        skipNull: true,
        skipEmptyString: true,
      },
    }
  );

  const onChangePage = (value) => {
    setParams({
      ...params,
      filesHistoryPage: value,
    });
  };

  const getCurrentPage = () => {
    return (params?.filesHistoryPage || PAGINATION_DEFAULT.page) - 1;
  };

  return (
    <AccordionItem>
      <AccordionHeader targetId="2" className="mt-0 fw-bold">
        {t("detail.mdb_opi_files_section")}
      </AccordionHeader>
      <AccordionBody accordionId="2">
        <TableCommon
          loading={isFetchingFileHistories}
          columns={columns({ t })}
          data={fileHistories?.items || []}
          onChangePage={onChangePage}
          tableFixed
          tableClassName="table table-custom table-collapse table-fixed"
          customClassName="overflow-auto simulation-table"
          pageCurrent={getCurrentPage()}
          pageCount={fileHistories?.pagination?.total_page}
          totalItem={fileHistories?.pagination?.total}
          pageSize={PAGINATION_DEFAULT.smallPageSize}
          classTableHead="table-header-custom"
          classTableBody="table-body-custom"
        />
      </AccordionBody>
    </AccordionItem>
  );
};

export default FilesHistory;
